// @flow
import './MetadataTimeline.css';
import '../common/Popup.css';
import * as React from 'react';
import Portal from './../common/Portal';
import $ from 'jquery';
import _ from 'lodash';
import classNames from 'classnames';
import Draggable, { DraggableData } from 'react-draggable';
import MetadataTimelineRow from './MetadataTimelineRow';
import RangeInput from '../common/RangeInput';
import MetadataTimelineSidebarRow from './MetadataTimelineSidebarRow';
import MetadataTimelineHeader, { MetadataTimelineSeekChangeEvents } from './MetadataTimelineHeader';

import VideoController from './VideoController';
import PlaybackTimer from '../tabs/PlaybackTimer';
import type { TimelineCellConfig } from './getTimelineCellConfig';
import getTimelineCellConfig from './getTimelineCellConfig';
import Store from '../store/Store';
import StoreListener from '../store/StoreListener';
import { toSMPTE, convertSecondsToSMPTE } from '../util/VideoUtil';
import {
  ACTIVE_TIMELINE_NODE,
  AI_METADATA,
  SELECTED_ASSET_AI_METADATA,
  CLIP_FROM_TIMELINE,
  GLOBAL_SPINNER,
  ONLOCATE_VIA_ADV_SEARCH,
  IS_CLIPMODE_DRAGGING,
  SHOW_NOTIFICATION_PANEL,
  KEYFRAME_METADATA
} from '../store/Constants';
import TimelinePopup from './TimelinePopup';
import { animateScroll, isInRect } from '../util/DOMUtil';
import type { ClipConfig } from '../hoc/Clip';
import HashMap from '../protocol/HashMap';
import MetadataVideoOverlay from './MetadataVideoOverlay';
import Button from '../common/Button';
import DataTimelineDialog from './DataTimelineDialog';
import DataTimeline from '../protocol/DataTimeline';
import TimelineDatapointDialog from './TimelineDatapointDialog';
import MetadataUtil, { updateKeyframeMetadata } from '../util/MetadataUtil';
import { KeyFrameMetadataEntry, RepoItem, Point } from '../autogenerated/ZoomBridge';
import { toast } from '../store/StoreUtil';
import { getErrorMessage } from '../util/ErrorUtil';
import t, { i18nHas } from '../i18n/I18n';
import KeyboardShortcuts from '../keyboard-shortcuts/KeyboardShortcuts';
import KeydownConfig from '../keyboard-shortcuts/KeydownConfig';
import { GET_ACTIONS, KeyCode } from '../util/Constants';
import { ThemeSetup } from '../themes/ThemeSetup';
import { PROP_NAME_TO_PROP_INFO, GROUP_CODE_TO_GROUP_INFO } from '../store/Constants';
import Modal from '../modals/Modal2';
import workerScript from '../workers/castData.worker';
const debug = require('../debug/debug')('wc:video:MetadataTimeline');
type UpdateKeyframeMetadataObj = {
  stopTimeMs: string,
  stopTime: number,
  data: any,
  startTimeMs: string,
  startTime: number
};

type TimelineElement = {
  id: any,
  key: string,
  value: string,
  startTimeMs: number,
  stopTimeMs: number
};

type Props = {
  asset: RepoItem,
  clipConfig: ClipConfig,
  controller: VideoController,
  videoFrameRate: number,
  onResize: Function,
  metadataTimelineSeekChangeEvents: MetadataTimelineSeekChangeEvents,
  ACTIVE_TIMELINE_NODE?: ?Object,
  AI_METADATA?: HashMap,
  SELECTED_ASSET_AI_METADATA?: HashMap,
  IS_CLIPMODE_DRAGGING?: boolean,
  GLOBAL_SPINNER?: boolean,
  KEYFRAME_METADATA?: HashMap,
  CLIP_FROM_TIMELINE?: boolean,
  PROP_NAME_TO_PROP_INFO: HashMap,
  setAssetKeyframeAiData: Function,
  setOnLocateNodeSelection: Function,
  setDeleteTimelineRow: Function,
  mediaLoadFailed:boolean,
  isHide: boolean,
  onDataTimeLineClick : Function 
};

type State = {
  metadata: Object[],
  metadataByFrame: HashMap,
  width: number,
  actioneAlert: boolean,
  actionMsg: ?string,
  drawing: boolean,
  height: number,
  scale: number, // The actual scale (debounced updates)
  inputScale: number, // The value for the range input (non-debounced updates)
  hoveredRow: ?string,
  selectedRow: ?Object,
  selectedRowLabel: ?string,
  mouseX: ?number,
  expandedRows: Object,
  disabledRows: Object,
  hasScrolledTop: boolean,
  hasScrolledLeft: boolean,
  cellConfig: TimelineCellConfig,
  activeRow: ?Object,
  dataTimeline: ?DataTimeline,
  keyFrameMetadataEntry: ?KeyFrameMetadataEntry,
  dialog: 'datatimeline' | 'datapoint' | null,
  deleteWho: 'nodeContainer' | 'row' | null,
  isWriteTimeEnable: boolean,
  showKeyboardHelpHelpText: ?string,
  activeRowLabel: string,
  forceId: ?number,
  cleft: number,
  dataPointTarget: string,
  assetKeyframeAiData: Object[]
};

type TimelineKeyConfig = {
  startTime: number,
  endTime: number,
  startMarker: any
};

function isPolygon(o: Object) {
  return !!(o && o.object && o.object.boundingPoly);
}

const storeItems = [
  AI_METADATA,
  SELECTED_ASSET_AI_METADATA,
  ACTIVE_TIMELINE_NODE,
  IS_CLIPMODE_DRAGGING,
  GLOBAL_SPINNER,
  CLIP_FROM_TIMELINE,
  SHOW_NOTIFICATION_PANEL,
  PROP_NAME_TO_PROP_INFO
];

@StoreListener(storeItems)
export default class MetadataTimeline extends React.Component<Props, State> {
  _node: ?HTMLDivElement;
  _scrollXNode: ?HTMLDivElement;
  _scrollYNode: ?HTMLDivElement;
  _sidebarNode: ?HTMLDivElement;
  _progressBarNode: ?Element;
  _draggable: ?Draggable;
  _scrollLeft: ?Object;
  _lastMouseEventTime: number = 0;
  _lastX: number = 0;
  _lastLeft: number = 0;
  _isDraggingProgressBar: boolean = false;
  _ignoreActiveNodeChange: boolean = false;
  _didPopupAppearFromHover: boolean = false;
  _popupTimer: any;
  _scaleNodeRect: ClientRect;
  _timelineConfig: TimelineKeyConfig = { startTime: 0, endTime: 0, startMarker: null };
  setDefaultCheck: boolean = false;
  _videoduration: number = 0;
  _isTimeCodeUpdate = false;
  ctrlKeyPress: boolean = false;
  shiftKeyPress: boolean = false;
  clientX: number = 0;
  eventType: string = null;
  nodeContainer: Map<Number, Object> = new Map();
  rangeOfNodes: Array<Object> = [];
  firstSelectedNode: Object = null;
  lastSelectedNode: Object = null;
  isRangeCreated: boolean = false;
  selectedNodes: object = [];
  persistNodeContainer: boolean = false;
  dataArray: object = [];
  mouseSelection = React.createRef();
  lastX: number = 0;
  x1local: number;
  x2local: number;
  updateRange: boolean;
  // isDeletePopupOpen: boolean = false;
  dragStart: boolean = false;
  isTimelineResized: boolean = false;
  isExistInContainer: boolean = false;
  popupRef: object = null;
  isAiNodePresent: boolean = false;
  isVideoPlaying: boolean = true;
  worker = new workerScript();
  isWorkerRunning = false;
  workerActions = null;
  state = {
    metadata: [], //MetadataUtil.transformTimelineMetadata(this.props.AI_METADATA, this.props.KEYFRAME_METADATA),
    width: window.innerWidth ? window.innerWidth - 600 : 100,
    metadataByFrame: new Map(),
    isDrag: false,
    height: 100,
    scale: 1,
    inputScale: 1,
    expandedRows: {},
    disabledRows: {},
    hoveredRow: null,
    selectedRow: null,
    selectedRowLabel: null,
    mouseX: null,
    hasScrolledTop: false,
    hasScrolledLeft: false,
    cellConfig: { times: [], step: 1 },
    activeRow: null,
    dataTimeline: null,
    keyFrameMetadataEntry: null,
    dialog: null,
    isWriteTimeEnable: false,
    showKeyboardHelpHelpText: null,
    activeRowLabel: '',
    forceId: 1,
    isDeletePopOpen: false,
    isMouseDown: false,
    drawBoxHeight: 0,
    drawBoxWidth: 0,
    drawBoxTop: 0,
    drawBoxTopLeft: 0,
    drawing: false,
    cleft: 0,
    updateTimeline: 0,
    isDelete: false,
    isPopupHide: false,
    actioneAlert: false,
    actionMsg: null,
    deleteWho: null,
    selectedAsset: new RepoItem()
  };

  componentDidMount() {
    this.props.setOnLocateNodeSelection ? this.props.setOnLocateNodeSelection(this.onLocateNodeSelection) : null;
    this.props.setDeleteTimelineRow ? this.props.setDeleteTimelineRow(this.deleteTimelineRow) : null;
    this.props.controller.addListener('change:currentTime', this.onControllerChange);
    this.props.controller.addListener('change:duration', this.onControllerChange);
    window.addEventListener('resize', this.onResize);
    this.props.metaDataReference(this);
    this.setWidth(this.props.widthOfCol);
    this.addKeyListeners();
    this.onUpdateKeyFrameData(this.props.assetKeyframeMetadata);
    document.addEventListener('mouseup', this.onMetaDataMouseUp);
    document.addEventListener('keydown', this.keyDown);
    this.registerWorkerListners();
    this.getWorkerActions();
  }

  registerWorkerListners = () => {
    if(this.worker) {
      this.worker.onmessage = message => {
        const data = message.data;
        if(data.action === GET_ACTIONS) {
          this.workerActions = data.payload;
        }
        if(this.workerActions) {
          switch(data.action) {
            case this.workerActions.DO_CASTING: this.setState({metadataByFrame: data.payload})
            break;
            default: break;
          }
        }
      }
    }
  }

  
  getWorkerActions = () => {
    if(this.worker) 
    this.worker.postMessage({action: GET_ACTIONS, payload: {}});
  }

  deleteTimelineRow = (selectedAsset, timelineNodes) => {
    this.timelineNodes = timelineNodes;
    this.selectedAsset = selectedAsset;
    this.setState({ isDelete: true, isPopupHide: true, deleteWho: 'row' });
  };

  deleteRow = async () => {
    this.clearNodeContainer();
    await MetadataUtil.deleteTimelineRow(this.selectedAsset, this.timelineNodes);
    this.selectedAsset = this.timelineNodes = null;
    this.fetchKeyframeMetadata();
  };

  async componentWillReceiveProps(nextProps: Props) {
    if(nextProps.asset.getFuid() !== this.state.selectedAsset.getFuid()) {
      this.setState({selectedAsset: nextProps.asset, metadata: []})
    }
    if (
      nextProps.assetAiData !== this.props.assetAiData ||
      nextProps.assetKeyframeMetadata !== this.props.assetKeyframeMetadata
    ) {
      debug('[componentWillReceiveProps()] AI_METADATA/KEYFRAME_METADATA changed, calling transformMetadata()');
      this.setState(
        {
          metadata: MetadataUtil.transformTimelineMetadata(nextProps.assetAiData, nextProps.assetKeyframeMetadata)
        },
        () => {
          let newHeight: number = 100 + 36 * this.state.metadata.length;
          let windowHeight = document.querySelector('[name=AssetVideoPreview]').offsetHeight / 2;
          if (newHeight > windowHeight) {
            newHeight = windowHeight;
          }
          if (!this.isTimelineResized) {
            this.setState({
              height: newHeight
            });
          }
          if (this.state.metadata.length) {
            // if (!this.state.activeRow) {
              this.onToggleActiveRow(
                this.state.metadata[0].items,
                this.state.metadata[0].label ? this.state.metadata[0].label : this.state.metadata[0].groupName
              );
              this.setDefaultCheck = true;
            // }
            this.props.setAssetKeyframeAiData
              ? this.props.setAssetKeyframeAiData(this.state.metadata, nextProps.assetKeyframeMetadata)
              : null;
          }
        }
      );
    }
    if(nextProps.videoDuration && this.state.metadata.length && !this.state.metadataByFrame.size && nextProps.videoFrameRate) {
      try{
          if(this.worker && !this.isWorkerRunning && this.workerActions) {
              this.isWorkerRunning = true;
              this.worker.postMessage({action: this.workerActions.DO_CASTING, payload: {duration: nextProps.videoDuration, videoFrameRate: nextProps.videoFrameRate, metadata: this.state.metadata} })
          } 
      } catch(e) {
        console.log(e)
      };
    }
    // if (!this.state.metadata.length || this.props.assetAiData != nextProps.assetAiData || this.props.KEYFRAME_METADATA != nextProps.KEYFRAME_METADATA) {
    //   this.setState(
    //     {
    //       metadata: MetadataUtil.transformTimelineMetadata(nextProps.assetAiData, nextProps.KEYFRAME_METADATA)
    //     })
    // }

    if (this._videoduration !== this.props.controller.duration || nextProps.widthOfCol !== this.props.widthOfCol) {
      this.setWidth(nextProps.widthOfCol);
    }

    if (nextProps[SHOW_NOTIFICATION_PANEL] !== this.props[SHOW_NOTIFICATION_PANEL]) {
      this.onResize();
    }

    const node = nextProps[ACTIVE_TIMELINE_NODE];
    const prevNode = this.props[ACTIVE_TIMELINE_NODE];

    if (node && node !== prevNode) {
      if (this._didPopupAppearFromHover) {
        this.addPopupMouseMoveListener();
      }

      if (this._ignoreActiveNodeChange) {
        debug('[componentWillReceiveProps()] _ignoreActiveNodeChange is set');
      } else {
        debug('[componentWillReceiveProps()] scrolling to new active node');
        const { startTimeMs, stopTimeMs } = node;
        let currentTime;
        if (nextProps.GLOBAL_SPINNER) {
          // Hack. We want different behavior when navigating from the advanced search
          // screen. Currently, GLOBAL_SPINNER is a good way to check for that case.
          currentTime = startTimeMs / 1000;
        } else {
          const start = startTimeMs / 1000;
          const end = stopTimeMs / 1000;
          currentTime = start + (end - start) / 2;
        }

        nextProps.controller.playing = false;
        nextProps.controller.setCurrentTime(currentTime, true);

        const p1 = animateScroll(this._scrollXNode, this._progressBarNode, { axis: 'X', dest: 'CENTER' });

        const el = this._node.querySelector(`[data-nodeid="${node._cid}"]`);
        if (el) {
          const p2 = animateScroll(this._scrollYNode, el, { axis: 'Y', dest: 'CENTER', speed: 'FAST' });
          await Promise.all([p1, p2]);
          this.forceUpdate();
        }
      }

      // Manually highlight the active node here. Before, we were passing an
      // activeNodeId flag to all nodes. That caused huge performance issues.
      const el = this._node.querySelector(`[data-nodeid="${node._cid}"]`);
      if (el) {
        const color = el.dataset.color;
        el.setAttribute('fill', `url(#linear-gradient-${color})`);
      }
    } else if (!node && prevNode) {
      const el = this._node.querySelector(`[data-nodeid="${prevNode._cid}"]`);
      if (el) {
        el.setAttribute('fill', '#0000');
      }
    }
  }

  componentWillUpdate(nextProps: Props, nextState: State) {
    if (nextState.scale !== this.state.scale) {
      this._scrollLeft = {
        percent: this.getProgressLeft() / this._scrollXNode.scrollWidth,
        offset: this._progressBarNode.getBoundingClientRect().left - this._scrollXNode.getBoundingClientRect().left
      };

      debug('[componentWillUpdate()] setting this._scrollLeft=', this._scrollLeft);
      this._lastMouseEventTime = Date.now();
    }
  }

  componentDidUpdate() {
    if (this._scrollLeft) {
      const scrollLeft = this._scrollLeft.percent * this._scrollXNode.scrollWidth - this._scrollLeft.offset;
      debug('[componentWillUpdate()] setting this._scrollXNode.scrollLeft=', scrollLeft);
      this._scrollXNode.scrollLeft = scrollLeft;
      this._scrollLeft = null;
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
    this.removeMouseListeners();
    this.removePopupMouseMoveListener();
    this.props.controller.removeListener('change:currentTime', this.onControllerChange);
    this.props.controller.removeListener('change:duration', this.onControllerChange);
    this.removeKeyListener();
    document.removeEventListener('mouseup', this.onMetaDataMouseUp);
    document.removeEventListener('keydown', this.keyDown);
    if(this.worker) {
      this.worker.terminate(); // Terminate the worker thread
    }
  }

  highlightStoreNode = () => {
    const item = Store.get(ACTIVE_TIMELINE_NODE);
    if (item && this.getRect(item)) {
      Store.put(ONLOCATE_VIA_ADV_SEARCH, false);
      const e = new MouseEvent('click');
      const data = _.find(this.state.metadata, { key: item.key });
      const { label } = MetadataTimelineSidebarRow.extractLabelAndLength(data);
      this.onToggleActiveRow(data.items, label);
      this.onLocateNodeSelection(e, item, item.key);
    }
  };

  //*************** Dragging feature *******/

  getMinMaxTimeNode = (selectedNodes: Array<Object>) => {
    let localStartTimeMs = selectedNodes[0].startTimeMs,
      localStopTimeMs = selectedNodes[0].stopTimeMs;
    let minStartTimeNode, maxStopTimeNode;
    selectedNodes.forEach((ele) => {
      if (ele.startTimeMs <= localStartTimeMs) {
        minStartTimeNode = ele;
        localStartTimeMs = ele.startTimeMs;
      }
      if (ele.stopTimeMs >= localStopTimeMs) {
        maxStopTimeNode = ele;
        localStopTimeMs = ele.stopTimeMs;
      }
    });
    return { minStartTimeNode, maxStopTimeNode };
  };

  onMouseDown = (e: MouseEvent, data: object) => {
    e.stopPropagation();
    e.preventDefault();
    this.isExistInContainer = false;
    this.selectedNodes = [];
    if (this.nodeContainer.size) {
      this.nodeContainer.forEach((node) => {
        if (node._id === data._id) this.isExistInContainer = true;
        this.selectedNodes.push(node);
      });
    }
    if (!this.nodeContainer.size || (!this.isExistInContainer && !(e.ctrlKey || e.metaKey || e.shiftKey))) {
      this.clearNodeContainer();
      this.selectedNodes = [];
      this.selectedNodes.push(data);
    }
    //**********end************
    this.lastX = e.clientX;
    const { minStartTimeNode, maxStopTimeNode } = this.getMinMaxTimeNode(this.selectedNodes);
    this.x1local = this._node.querySelector(`[id="${minStartTimeNode._id}"]`).getAttribute('x1');
    this.x2local = this._node.querySelector(`[id="${maxStopTimeNode._id}"]`).getAttribute('x2');
  };

  proceedDrag = (data: object) => {
    if (this.selectedNodes.length === 1) {
      if (this.isAiNode(data)) return false;
      else return true;
    }
    if (this.selectedNodes.length > 1) {
      if (this.validateTimelineDragAction()) return true;
      else return false;
    }
  };

  mouseMove = (e: MouseEvent, data) => {
    if (!this.proceedDrag(data)) {
      this.setActioneAlert(t('NOT_SUPPORT_MOVE_ACTION'));
    } else {
      if (this.selectedNodes.length === 1) this.putNodeIntoNodeContainer(this.selectedNodes[0]);
      const isNodePresent = this.selectedNodes.some(function(element) {
        return element._id === data._id;
      });
      if (isNodePresent) {
        this.setState({ isDrag: true });
        const offsetWidth = this._node.querySelector(`[name="MetadataTimelineRow"]`).offsetWidth;
        if (this.selectedNodes.length) {
          if (e.clientX > this.lastX) {
            const cleft = this.state.cleft + (e.clientX - this.lastX);
            if (parseInt(this.x2local) + parseInt(cleft) < offsetWidth) {
              this.state.cleft = cleft;
              this.selectedNodes.map((arr, i) => {
                this._node.querySelector(`[id="${arr._id}"]`).style.transform = 'translateX(' + cleft + 'px)';
              });
            }
          } else {
            const cleft = this.state.cleft - (this.lastX - e.clientX);
            if (parseInt(this.x1local) + parseInt(cleft) > 0) {
              this.state.cleft = cleft;
              this.selectedNodes.map((arr, i) => {
                this._node.querySelector(`[id="${arr._id}"]`).style.transform = 'translateX(' + cleft + 'px)';
              });
            }
          }
        }

        this.lastX = e.clientX;
      }
    }
  };

  mouseUp = (e: MouseEvent, type, data) => {
    const isNodePresent = this.selectedNodes.some(function(element) {
      return element._id === data._id;
    });
    if (isNodePresent) {
      const pps = this.getPPS();
      if (this.selectedNodes.length) {
        if (!this.state.isDrag) {
          // this.onTimelineNodeMouseClick(e, type, data);
        } else {
          this.onRowMouseLeave();
          this.dragHappen = true;
          const newArr = new Array();
          this.selectedNodes.map((arr, i) => {
            let width = this.getRect(arr).width;
            let nodeStartTime =
              parseInt(this._node.querySelector(`[id="${arr._id}"]`).getAttribute('x1')) + parseInt(this.state.cleft);
            let nodeEndTime = nodeStartTime + width;
            let secondsStart = nodeStartTime / pps;
            let secondsEnd = nodeEndTime / pps;
            let secsDiff = secondsEnd - secondsStart;
            secondsStart = secondsStart < 0 ? 0 : secondsStart;
            if (secondsEnd < 0) {
              secondsEnd = 0 + parseInt(secsDiff);
            }
            newArr.push({
              stopTimeMs: 'stopTimeMs',
              stopTime: Math.round(secondsEnd * 1000),
              data: arr,
              startTimeMs: 'startTimeMs',
              startTime: Math.round(secondsStart * 1000)
            });
          });
          this.x1local = parseInt(this.x1local) + parseInt(this.state.cleft);
          this.x2local = parseInt(this.x2local) + parseInt(this.state.cleft);
          this.lastX = 0;
          this.state.cleft = 0;
          this.updateKeyframeMetadataData(newArr);
        }
      }
      this.setState({ isDrag: false });
      this.persistNodeContainer = true;
      this.selectedNodes = [];
    } else {
      this.persistNodeContainer = true;
    }
  };

  //************************** */
  addMouseListeners = () => {
    document.addEventListener('mousemove', this.onProgressBarMouseMove);
    document.addEventListener('mouseup', this.onProgressBarMouseUp);
  };

  addPopupMouseMoveListener = () => {
    document.addEventListener('mousemove', this.onPopupMouseMove);
  };

  removeMouseListeners = () => {
    document.removeEventListener('mousemove', this.onProgressBarMouseMove);
    document.removeEventListener('mouseup', this.onProgressBarMouseUp);
  };

  removePopupMouseMoveListener = () => {
    document.removeEventListener('mousemove', this.onPopupMouseMove);
  };

  addKeyListeners = () => {
    KeyboardShortcuts.add(new KeydownConfig('TIMELINE_VIDEO', this.onKeyDownI, [KeyCode.I]));
    KeyboardShortcuts.add(new KeydownConfig('TIMELINE_VIDEO', this.onKeyDownO, [KeyCode.O]));
    KeyboardShortcuts.add(new KeydownConfig('TIMELINE_VIDEO', this.onKeyDownESCAPE, [KeyCode.ESCAPE]));
    KeyboardShortcuts.add(new KeydownConfig('TIMELINE_VIDEO', this.onEnterPress, [KeyCode.ENTER]));
  };

  removeKeyListener = () => {
    KeyboardShortcuts.remove('TIMELINE_VIDEO');
  };

  onEnterPress = () => {
    const { isDelete, actioneAlert, deleteWho } = this.state;
    if (isDelete) {
      deleteWho === 'row' ? this.deleteRow() : this.deleteKeyFrameMetadata();
      this.deleteKeyFrameMetadata();
    }
    if (actioneAlert) {
      this.closeActionAlert();
    }
  };

  keyDown = (e: KeyboardEvent) => {
    if (e.target.tagName === 'INPUT') {
    } else {
      if (e.keyCode === KeyCode.DELETE) {
        this.deleteMultipleNodes();
      } else {
        if (e.keyCode === KeyCode.BACKSPACE && navigator.appVersion.indexOf('Mac') !== -1) {
          this.deleteMultipleNodes();
        }
      }
    }
  };

  onUpdateKeyFrameData = (keyFrameData: KeyFrameMetadataEntry[]) => {
    const { metadata } = this.state;
    this.setState(
      {
        metadata: MetadataUtil.transformTimelineMetadata(this.props.assetAiData, keyFrameData)
      },

      () => {
        if (this.nodeContainer.size && !this.state.isDrag) {
          this.nodeContainer.forEach((ele) => {
            const domElement = document.querySelector(`[id="${ele._id}"]`);
            if (domElement) {
              domElement.style.transform = 'translateX(0px)';
            }
          });
        }

        let index: number = this.state.activeRowLabel
          ? _.findIndex(this.state.metadata, { label: this.state.activeRowLabel })
          : -1;
        let newHeight: number = 100 + 36 * this.state.metadata.length;
        let windowHeight = document.querySelector('[name=AssetVideoPreview]').offsetHeight / 2;
        if (newHeight > windowHeight) {
          newHeight = windowHeight;
        }
        if (!this.isTimelineResized) {
          this.setState({
            height: newHeight
          });
        }
        if (this.state.metadata.length) {
          if (index == -1 || !this.state.activeRow) {
            this.onToggleActiveRow(
              this.state.metadata[0].items,
              this.state.metadata[0].label ? this.state.metadata[0].label : this.state.metadata[0].groupName
            );
            this.setDefaultCheck = true;
          } else {
            this.onToggleActiveRow(this.state.metadata[index].items, this.state.activeRowLabel);
          }
        }
        this.props.setAssetKeyframeAiData ? this.props.setAssetKeyframeAiData(this.state.metadata, keyFrameData) : null;
      }
    );
  };
  isKeyDownIProceed = () => {
    const { selectedRow, activeRow } = this.state;
    if (selectedRow) {
      if (this.isAiNode(selectedRow)) return false;
      else return true;
    } else if (activeRow && activeRow.length) {
      if (this.isAiNode(activeRow[0])) return false;
      else return true;
    } else return true;
  };
  onKeyDownI = () => {
    if (!this.isKeyDownIProceed()) {
      this.setActioneAlert(t('NOT_SUPPORT_ADD_ACTION'));
    } else {
      const { isWriteTimeEnable, activeRow } = this.state;
      const { controller } = this.props;
      this._timelineConfig.startMarker = null; //Reset the previous mark.
      this._timelineConfig.startTime = controller.currentTime;
      this.isVideoPlaying = controller.playing;
      // if (!activeRow || !activeRow.length) {
      //   //controller.playing = false;
      //   //this.onAddClick();
      //   return;
      // }
      if (isWriteTimeEnable) {
        this.clearTimelineConfig();
      }
      if (!isWriteTimeEnable) {
        this.setState({ showKeyboardHelpHelpText: 'ADD_DATA_POINT_KEYBOARD_SHORT_HELP_TEXT' }, () => {
          setTimeout(() => {
            this.setState({ showKeyboardHelpHelpText: null });
          }, 3000);
        });
      }
      this.setState({ isWriteTimeEnable: !isWriteTimeEnable }, () => {
        if (!controller.playing) {
          if (this.state.isWriteTimeEnable) controller.setCurrentTime(controller.currentTime + 0.5, true);
          else controller.setCurrentTime(controller.currentTime - 0.5, true);
        }
      });
    }
  };

  onKeyDownO = () => {
    const { isWriteTimeEnable, activeRow } = this.state;
    const { controller } = this.props;
    if (!activeRow || !activeRow.length) {
      //this.onKeyDownESCAPE();
      controller.playing = false;
      this.setTimelineData(this._timelineConfig.startTime * 1000, controller.currentTime * 1000, controller.frameRate);
      return;
    }
    if (!this.state.isWriteTimeEnable) {
      return;
    }
    controller.playing = false;
    //Right now playing is set to false. It might take few milliseconds to pause the player. Taking current time before pause won't be correct.
    //And taking current just after pause may differ from what appears on the screen because of asynchronous nature of js
    //So doing it in calllater, to give JS some chance.
    setTimeout(() => {
      this._timelineConfig.endTime = controller.currentTime;
      this.openTimelinePopup();
    }, 1);
  };

  onKeyDownESCAPE = () => {
    if (this.state.isDelete) {
      this.onCloseDeletePopup();
    }
    if (this.state.actioneAlert) this.closeActionAlert();

    this.closeTimelineEditing();
  };

  clearTimelineConfig = () => {
    const { controller } = this.props;
    if (controller.playing) {
      controller.playing = false;
    }
  };

  closeTimelineEditing = () => {
    this.clearTimelineConfig();
    this.setState({ isWriteTimeEnable: false });
  };

  openTimelinePopup = () => {
    this.clearNodeContainer();
    const { metadata, activeRow, selectedRow } = this.state;
    const { startTime, endTime } = this._timelineConfig;
    const map = new HashMap();
    if (metadata.length) {
      if (selectedRow) {
        map.put(selectedRow.key, '');
      } else {
        metadata.map((r, i) => {
          if (_.isEqual(MetadataTimelineSidebarRow.extractLabelAndLength(r).label, this.state.activeRowLabel)) {
            map.put(r.key, '');
          }
          // if (r.value[0].jsondata.sourceEngineName == activeRow[0].jsondata.sourceEngineName) {
          //   map.put(r.key, '');
          // }
        });
      }
      if (map.size() > 0) {
        const entry = new KeyFrameMetadataEntry()
          .setId(-1)
          .setStartTime(startTime * 1000)
          .setEndTime(endTime * 1000)
          .setMetadataMap(map);
        this.setState({ keyFrameMetadataEntry: entry, dialog: 'datapoint' });
      }
    }
  };

  fetchKeyframeMetadata = async () => {
    try {
      if (debug.enabled) {
        debug('[fetchKeyframeMetadata()] Fetching keyframe metadata:', this.props.asset);
      }
      const keyframeMetadata = await MetadataUtil.getKeyFrameMetadata(this.props.asset);

      if (keyframeMetadata && keyframeMetadata.length) {
        this.onUpdateKeyFrameData(keyframeMetadata);
        Store.put(KEYFRAME_METADATA, keyframeMetadata);
      } else {
        this.setState({ activeRow: null, activeRowLabel: '' }, () => {
          this.onUpdateKeyFrameData(keyframeMetadata);
        });
        Store.put(KEYFRAME_METADATA, []);
      }
    } catch (err) {
      debug('[fetchKeyframeMetadata()] error: ', err);
      Store.put(KEYFRAME_METADATA, null);
    }
  };

  setWidth = (colWidth) => {
    if (!this._node) {
      return;
    }
    this._videoduration = this.props.controller.duration;
    const width = colWidth - 202;//this._node.getBoundingClientRect().width - 200;
    this.setState({
      width,
      cellConfig: getTimelineCellConfig(this.state.scale, width, this.props.controller.duration)
    });
  };

  setActiveNode = (data: Object) => {
    this._ignoreActiveNodeChange = true;
    setTimeout(() => (this._ignoreActiveNodeChange = false), 250);
    Store.put(ACTIVE_TIMELINE_NODE, data);
  };

  maybeScrollToActiveNode = async (node: Element) => {
    const rect = node.getBoundingClientRect();
    const parent1Rect = this._scrollYNode.getBoundingClientRect();
    const parent2Rect = this._scrollXNode.getBoundingClientRect();
    const diffTop = rect.top - parent1Rect.top;
    const diffBottom = rect.bottom - parent1Rect.bottom;
    if (diffTop < 0) {
      this._scrollYNode.scrollTop += diffTop;
    } else if (diffBottom > 0) {
      this._scrollYNode.scrollTop += diffBottom;
    }

    const diffLeft = rect.left - parent2Rect.left;
    const diffRight = rect.right - parent2Rect.right;
    if (diffLeft < 0) {
      this._scrollXNode.scrollLeft += diffLeft;
    } else if (diffRight > 0) {
      this._scrollXNode.scrollLeft += diffRight;
    }

    this.forceUpdate();
  };

  clearPopupTimer = () => {
    if (!this._popupTimer) {
      debug('[clearPopupTimer()] timer already stopped. return.');
      return;
    }

    debug('[clearPopupTimer()] stopping timer');
    clearTimeout(this._popupTimer);
    this._popupTimer = null;
  };

  onResize = () => {
    this.setWidth(this.props.widthOfCol);
  };

  onScaleNodeRef = (node: ?HTMLDivElement) => {
    if (node) {
      this._scaleNodeRect = node.getBoundingClientRect();
    }
  };

  onControllerChange = () => {
    const timeSinceLastMouseEvent = Date.now() - this._lastMouseEventTime;
    if (timeSinceLastMouseEvent < 500) {
      return;
    }

    if (this._isDraggingProgressBar) {
      return;
    }

    if (this.props.IS_CLIPMODE_DRAGGING) {
      return;
    }

    const node = this._progressBarNode;
    if (!node) {
      return;
    }

    const rect = node.getBoundingClientRect();
    const parentRect = this._scrollXNode.getBoundingClientRect();
    if (rect.left > parentRect.right - 25 && rect.left < parentRect.right + 25) {
      const scrollLeft = parentRect.width / 2;
      debug('[onControllerChange()] updating scrollLeft to ', scrollLeft);
      this._scrollXNode.scrollLeft += scrollLeft;
    }
  };

  onResizeStop = (e: MouseEvent, data: DraggableData) => {
    debug('[onResizeStop()] data: ', data);
    this.isTimelineResized = true;
    let height = this.state.height - data.y;
    height = Math.max(height, 75);
    height = Math.min(height, window.innerHeight - 225);
    this.setState({ height });
    this._draggable.setState({ y: 0 });
    this.props.onResize();
  };

  onProgressBarMouseDown = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    this._lastX = e.clientX;
    this._lastLeft = this.getProgressLeft();
    this.addMouseListeners();
  };

  onProgressBarMouseMove = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    const { isWriteTimeEnable } = this.state;
    const { startTime } = this._timelineConfig;

    if (!this._isDraggingProgressBar) {
      this._isDraggingProgressBar = true;
    }

    const diff = e.clientX - this._lastX;
    let time = (this._lastLeft + diff) / this.getPPS();
    if (time < 0) time = 0;
    if (time > this.props.controller.duration) time = this.props.controller.duration;
    debug('[onProgressBarMouseMove()] data: ', {
      clientX: e.clientX,
      lastX: this._lastX,
      lastLeft: this._lastLeft,
      diff,
      time
    });

    if (isWriteTimeEnable) {
      if (startTime > time) {
        return;
      }
    }
    this.props.controller.setCurrentTime(time, true);
    this._lastX = e.clientX;
    this._lastLeft = this.getProgressLeft();
  };

  onProgressBarMouseUp = () => {
    this._isDraggingProgressBar = false;
    this.removeMouseListeners();
  };

  onPopupMouseMove = (e: MouseEvent) => {
    if (!$(e.target).hasClass('transparent-background')) {
      return;
    }

    const pad = 20;
    const rect = e.target.firstElementChild.getBoundingClientRect();
    const paddedRect = {
      top: rect.top - pad,
      right: rect.right + pad,
      bottom: rect.bottom + pad,
      left: rect.left - pad
    };

    const inPopup = isInRect(paddedRect, e.clientX, e.clientY);
    if (inPopup) {
      this.clearPopupTimer();
    } else if (!this._popupTimer) {
      debug('[onPopupMouseMove()] starting this._popupTimer');
      this._popupTimer = setTimeout(this.maybeClosePopup, 500);
    }
  };

  onScaleChange = (e: MouseEvent, val) => {
    if (this.updateRange) {
      if (this._scrollYNode) {
        this._scrollYNode.style.opacity = '0.5';
      }
      this.persistNodeContainer = true;
      const inputScale = parseFloat(e.target.value);
      this.setState({ inputScale });
      this.onScaleChangeDebounced(inputScale);
    }
  };

  onScaleChangeDebounced = _.debounce((scale: number) => {
    debug('[onScaleChangeDebounced(scale)] sclae = %s ', scale);
    this.setState(
      {
        scale,
        cellConfig: getTimelineCellConfig(scale, this.state.width, this.props.controller.duration)
      },
      () => {
        if (this._scrollYNode) {
          this._scrollYNode.style.opacity = '';
        }
      }
    );
  }, 250);

  onToggleRow = (rowId: string) => {
    const expandedRows = { ...this.state.expandedRows };
    if (expandedRows[rowId]) {
      delete expandedRows[rowId];
    } else {
      expandedRows[rowId] = true;
    }

    this.setState({ expandedRows, height: this.getMaxHeight(expandedRows) });
  };

  onDisableRow = (rowId: string) => {
    const disabledRows = { ...this.state.disabledRows };
    if (disabledRows[rowId]) {
      delete disabledRows[rowId];
      this.state.selectedRow = null;
    } else {
      disabledRows[rowId] = true;
    }

    this.setState({ disabledRows });
  };

  onToggleActiveRow = (group: Object, label: string) => {
    // const activeRowLabel = label === this.state.activeRowLabel ? null : label;
    const activeRowLabel = label;
    this.setState(
      { activeRow: activeRowLabel ? _.sortBy(group, 'startTimeMs') : null, activeRowLabel: activeRowLabel },
      () => {
        debug('onToggleActiveRow() Active Row Label: %s row: %O', this.state.activeRowLabel, this.state.activeRow);
      }
    );
  };

  onSidebarWheel = (e: SyntheticWheelEvent) => {
    this._scrollYNode.scrollTop += e.deltaY;
  };

  onScrollX = (e: MouseEvent) => {
    this.setState({ updateTimeline: e.clientX });
    const node = e.target;
    if (node !== e.currentTarget) {
      return;
    }

    if (node.scrollLeft > 0 && !this.state.hasScrolledLeft) {
      this.setState({ hasScrolledLeft: true });
    } else if (node.scrollLeft === 0 && this.state.hasScrolledLeft) {
      this.setState({ hasScrolledLeft: false });
    }
  };

  onScrollY = (e: MouseEvent) => {
    const node = e.target;
    if (node !== e.currentTarget) {
      return;
    }

    this._sidebarNode.scrollTop = node.scrollTop;
    this._lastMouseEventTime = Date.now();

    if (node.scrollTop > 0 && !this.state.hasScrolledTop) {
      this.setState({ hasScrolledTop: true });
    } else if (node.scrollTop === 0 && this.state.hasScrolledTop) {
      this.setState({ hasScrolledTop: false });
    }
  };

  onRowMouseEnter = (row: Object) => {
    this.setState({ hoveredRow: row.key });
  };

  onRowMouseLeave = () => {
    this.setState({ hoveredRow: null });
  };

  onRowClick = (row: Object) => {
    event.stopPropagation();
    event.preventDefault();
    const val = this.state.selectedRow && this.state.selectedRow.key == row.key ? null : row;
    this.setState({ selectedRow: val, selectedRowLabel: val ? val.key : null }, () => {
      if (debug.enabled) {
        debug('[onRowClick()] Timeline row is selected', this.state.selectedRow);
      }
    });
  };

  onMetaDataMouseDown = (e: MouseEvent) => {
    // e.preventDefault();
    // e.stopPropagation();
    this.startDrawBox(e);
  };

  onMetaDataMouseMove = (e: MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({
      updateTimeline: e.clientX
    });

    this.coordinates = {
      clientX: e.clientX,
      clientY: e.clientY
    };
    if (this.state.drawing) {
      this.createDrawBox(e);
    }
  };

  onMetaDataMouseUp = (e: MouseEvent) => {
    // e.preventDefault();
    e.stopPropagation();
    if (this.state.drawing) {
      this.endDrawBox(e);
    }
  };

  startDrawBox = (e: MouseEvent) => {
    this.relativePosition = this._node.querySelector('[name="MetadataTimelineHeader"]').getBoundingClientRect().top;
    this.relativePosition = this.relativePosition - 5;
    this.x1 = e.clientX;
    this.y1 = e.clientY;
    this.relative_Y1 = e.clientY - this.relativePosition;
    this.setState({
      drawBoxTopLeft: this.x1,
      drawBoxTop: this.relative_Y1,
      drawing: true
    });
  };

  createDrawBox = (e: MouseEvent) => {
    this.clearNodeContainer();
    this.persistNodeContainer = true;
    this.x2 = e.clientX;
    this.y2 = e.clientY;
    this.relative_Y2 = e.clientY - this.relativePosition;
    this.setState({ isMouseDown: true });
    if (this.x1 < this.x2 && this.relative_Y1 > this.relative_Y2) {
      this.setState({
        drawBoxHeight: this.relative_Y1 - this.relative_Y2,
        drawBoxWidth: this.x2 - this.x1,
        drawBoxTop: this.relative_Y2,
        drawBoxTopLeft: this.x1
      });
    } else if (this.x1 > this.x2 && this.relative_Y1 > this.relative_Y2) {
      this.setState({
        drawBoxHeight: this.relative_Y1 - this.relative_Y2,
        drawBoxWidth: this.x1 - this.x2,
        drawBoxTop: this.relative_Y2,
        drawBoxTopLeft: this.x2
      });
    } else if (this.x1 > this.x2 && this.relative_Y1 < this.relative_Y2) {
      this.setState({
        drawBoxHeight: this.relative_Y2 - this.relative_Y1,
        drawBoxWidth: this.x1 - this.x2,
        drawBoxTop: this.relative_Y1,
        drawBoxTopLeft: this.x2
      });
    } else if (this.x1 < this.x2 && this.relative_Y1 < this.relative_Y2) {
      this.setState({
        drawBoxHeight: this.relative_Y2 - this.relative_Y1,
        drawBoxWidth: this.x2 - this.x1
      });
    } else {
      /*do nothing.*/
    }
  };

  endDrawBox = (e: MouseEvent) => {
    this.putAllNodeWithinSelectRange();
    if (this.nodeContainer.size === 1 && this.state.isMouseDown) {
      const { startTimeMs, stopTimeMs } = this.nodeContainer.values().next().value;
      this.setCursor(startTimeMs, stopTimeMs);
    }
    if (this.nodeContainer.size > 1 && this.state.isMouseDown) {
      this.props.controller.playing = false;
    }
    this.x1 = this.x2 = this.relative_Y1 = this.relative_Y2 = this.relativePosition = 0;
    this.setState({
      drawBoxTopLeft: 0,
      drawBoxTop: 0,
      drawBoxHeight: 0,
      drawBoxWidth: 0,
      isMouseDown: false,
      drawing: false
    });
  };

  isNodeInSelectionRange = (x: number, y: number, width: number) => {
    const x1 = x,
      x2 = x + width,
      y1 = y;
    if ((this.x1 < x1 && this.x2 > x1) || (this.x1 > x1 && this.x2 < x1)) {
      if ((this.y1 < y1 + 6 && this.y2 > y1 - 3) || (this.y1 > y1 && this.y2 < y1 + 6)) {
        return true;
      }
      return false;
    } else if ((this.x1 < x2 && this.x2 > x2) || (this.x1 > x2 && this.x2 < x2)) {
      if ((this.y1 < y1 + 6 && this.y2 > y1 - 3) || (this.y1 > y1 && this.y2 < y1 + 6)) {
        return true;
      }

      return false;
    } else if (this.x1 > x1 && this.x1 < x2) {
      if ((this.y1 > y1 && this.y2 < y1) || (this.y1 < y1 && this.y2 > y1)) {
        return true;
      } else return false;
    } else return false;
  };

  putAllNodeWithinSelectRange = () => {
    if (this.state.isMouseDown)
      this.state.metadata.forEach((row) => {
        row.items.forEach((node) => {
          const { x, y, width } = this.getRect(node);
          if (this.isNodeInSelectionRange(x, y, width)) {
            this.putNodeIntoNodeContainer(node);
          }
        });
      });
  };

  doPersistNodeContainer = (value: boolean) => {
    this.persistNodeContainer = value;
  };

  onMetaDataMouseClick = (e: MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    this.dragHappen = false;
    if (this.popupRef) {
      this.popupRef.persistHashMapState();
    }
    if (!this.ctrlKeyPress && !this.persistNodeContainer) {
      this.clearNodeContainer();
      Store.put(ACTIVE_TIMELINE_NODE, null);
      this.setState({ isDelete: false, isPopupHide: false });
    }
    this.persistNodeContainer = false;
  };

  putNodeIntoNodeContainer = (node: Object) => {
    this.nodeContainer.set(node._id, node);
    this.isAiNodePresentInContainer();
  };

  popOutNodeIntoNodeContainer = (key: number) => {
    this.nodeContainer.delete(key);
    this.isAiNodePresentInContainer();
  };

  clearNodeContainer = () => {
    this.nodeContainer.clear();
  };

  selectMultipleNodesByShiftKey = (node: Object) => {
    this.lastSelectedNode = node;
    if (this.firstSelectedNode && this.lastSelectedNode) {
      if (this.firstSelectedNode.key === this.lastSelectedNode.key) {
        if (this.firstSelectedNode._id !== this.lastSelectedNode._id) {
          this.clearNodeContainer();
          let LST, MST;
          if (this.lastSelectedNode.startTimeMs <= this.firstSelectedNode.startTimeMs) {
            LST = this.lastSelectedNode.startTimeMs;
          } else {
            LST = this.firstSelectedNode.startTimeMs;
          }
          if (this.lastSelectedNode.stopTimeMs >= this.firstSelectedNode.stopTimeMs) {
            MST = this.lastSelectedNode.stopTimeMs;
          } else {
            MST = this.firstSelectedNode.stopTimeMs;
          }
          for (let i = 0; i < this.state.metadata.length; i++) {
            if (this.state.metadata[i].key === this.firstSelectedNode.key) {
              this.state.metadata[i].items.forEach((node) => {
                if (node.startTimeMs >= LST && node.stopTimeMs <= MST) {
                  this.putNodeIntoNodeContainer(node);
                }
              });
              break;
            }
          }
        } else {
          //same node selected!
        }
      } else {
        //first and last selected node have different timeline row
        this.clearNodeContainer();
        let startNode = null,
          endNode = null;
        for (let i = 0; i < this.state.metadata.length; i++) {
          if (this.firstSelectedNode.key === this.state.metadata[i].key) {
            if (startNode) {
              endNode = this.getNodeObj(this.firstSelectedNode, i);
            } else {
              startNode = this.getNodeObj(this.firstSelectedNode, i);
            }
          }
          if (this.lastSelectedNode.key === this.state.metadata[i].key) {
            if (startNode) {
              endNode = this.getNodeObj(this.lastSelectedNode, i);
            } else {
              startNode = this.getNodeObj(this.lastSelectedNode, i);
            }
          }
        }
        this.extractNode(startNode, endNode);
      }
    } else {
      // do nothing!
    }
  };

  getNodeObj = (node: object, i: number) => {
    return {
      data: node,
      index: i,
      key: node.key
    };
  };

  extractNode = (startNode: Object, endNode: Object) => {
    for (let i = startNode.index; i <= endNode.index; i++) {
      if (this.state.metadata[i].key === startNode.key) {
        this.state.metadata[i].items.forEach((node) => {
          if (node.startTimeMs >= startNode.data.startTimeMs) this.putNodeIntoNodeContainer(node);
        });
      } else if (this.state.metadata[i].key === endNode.key) {
        this.state.metadata[i].items.forEach((node) => {
          if (node.stopTimeMs <= endNode.data.stopTimeMs) this.putNodeIntoNodeContainer(node);
        });
      } else {
        this.state.metadata[i].items.forEach((node) => {
          this.putNodeIntoNodeContainer(node);
        });
      }
    }
  };

  getAI_NodeRect = (node: object) => {
    const {startTimeMs, stopTimeMs} = node;
    const pps = this.getPPS();
    const x1 = startTimeMs > -1 ? (startTimeMs / 1000) * pps : (stopTimeMs / 1000) * pps;
    const x2 = stopTimeMs > -1 ? (stopTimeMs / 1000) * pps : (startTimeMs / 1000) * pps;
    const spare_div = document.getElementById(node.key);
    if(spare_div) {
      spare_div.style.width = `${x2-x1}px`;
      spare_div.style.left = `${x1}px`
      const rect = spare_div.getBoundingClientRect();
      return rect;
    } else {
      return null
    }
  }

  getRect = (node: Object) => {
    if (!this._node) {
      return null;
    }
    let el = null;

    if(node.isKeyFrameData) {
       el = this._node.querySelector(`[id="${node._id}"]`);
    } else {
      return this.getAI_NodeRect(node);
    }
  
    if (!el) {
      return null;
    } else {
      let { x, y, width, height, top, right, bottom, left } = el.getBoundingClientRect();
      if (height) {
        y = y + 7;
      }
      return { x, y, width, height, top, right, bottom, left };
    }
  };


  keyModifierActions = (node: Object) => {
    this.eventType = null;
    if (this.ctrlKeyPress && !this.shiftKeyPress) {
      if (this.nodeContainer.has(node._id)) this.popOutNodeIntoNodeContainer(node._id);
      else this.putNodeIntoNodeContainer(node);
    } else if (this.shiftKeyPress && !this.ctrlKeyPress) {
      if (this.firstSelectedNode === null) {
        this.setFirstSelectedNode(node);
      }
      this.selectMultipleNodesByShiftKey(node);
    } else {
      this.setFirstSelectedNode(node);
      this.clearNodeContainer();
      this.putNodeIntoNodeContainer(node);
    }
  };

  setFirstSelectedNode = (node: Object) => {
    this.firstSelectedNode = node;
    this.lastSelectedNode = null;
  };

  onTimelineNodeMouseMove = (e: MouseEvent | FocusEvent | number, rowId: string, data: Object) => {
    // e.stopPropagation();
    // e.preventDefault();
    if (!this.state.drawing) {
      this.setActiveNode(data);
    }
  };

  getFirstRowPosition = () => {
    let { x, y } = this._node.querySelector(`[name="MetadataTimelineRow"]`).getBoundingClientRect();
    let { width } = this._node.querySelector(`[name="Draggable"]`).getBoundingClientRect();
    return {
      viewPortX: x,
      viewPortY: y,
      viewPortWidth: width
    };
  };

  putNodeInVisibleRange = (node: Object) => {
    const { x, y, width } = this.getRect(node);
    const { viewPortX, viewPortY, viewPortWidth } = this.getFirstRowPosition();
    const { minLeft, maxLeft, maxTop, minTop } = this.getBoundaryOfRows();
    const scrollY = Math.abs(y - viewPortY - 14);
    const scrollX = Math.abs(x - viewPortX) + (width - viewPortWidth) / 2;
    if (!(y >= minTop && y <= maxTop)) this._scrollYNode.scrollTo(0, scrollY);
    if (!(x >= minLeft && maxLeft >= x + width)) this._scrollXNode.scrollTo(scrollX, 0);
  };

  getBoundaryOfRows = () => {
    const { top, left, height, width } = this.getPositionOfMetaDataTimeline();
    const postionMinMax = {
      maxTop: top + height - 7,
      minTop: top + 55,
      maxLeft: width,
      minLeft: 200,
      maxBottom: window.innerHeight - top - 39,
      minBottom: window.innerHeight - top - height + 21
    };
    return postionMinMax;
  };

  onLocateNodeSelection = (e: MouseEvent, item, key: string, fromAINode: boolean = false) => {
    // const itemsData = this.state.metadata.find((o) => o.key === key);
    // const locatedNode = itemsData.items.find((o) => o.id === id);
    // e.stopPropagation();
    // e.preventDefault();
    const { startTimeMs, stopTimeMs } = item;
    this.putNodeInVisibleRange(item);
    this.setCursor(startTimeMs, stopTimeMs);
    this.onTimelineNodeMouseClick(e, key, item, fromAINode);
    this.persistNodeContainer = false;
    if (debug.enabled) {
      debug('[onLocateNodeSelection()] node is selected by clicking on locate', item);
    }
  };

  setCursor = (startTime: number, endTime: number) => {
    const { controller } = this.props;
    const currentTime = (startTime + endTime) / 2;
    controller.setPlaying(false, true);
    controller.setCurrentTime(currentTime / 1000, true);
  };

  onTimelineNodeMouseEnter = (e: MouseEvent | FocusEvent | number, rowId: string, data: Object) => {
    e.stopPropagation();
    e.preventDefault();
    if (!this.state.drawing) {
      this.setEventType(e, false);
      this.onNodeClick(e.clientX, rowId, data);
    }
  };

  onTimelineNodeMouseLeave = (e: MouseEvent | FocusEvent | number, rowId: string, data: Object) => {
    e.stopPropagation();
    e.preventDefault();
    if (!this.state.drawing) {
      this.setEventType(e, false);
      this.setActiveNode(data);
    }
  };

  roundOfByFrame = (frame: number, videoFrameRate: number) => {
    const divider = videoFrameRate;
    const remainder = frame % videoFrameRate;
    if(videoFrameRate-remainder > remainder) {
      return frame - remainder;
    } else {
      return frame + remainder;
    }
  }

  fetchMetadataByFrame = (e: MouseEvent | FocusEvent | number, data: Object) => {
    const {metadataByFrame} = this.state;
    const {videoFrameRate} = this.props;
        const clientX = typeof e === 'number' ? e : e.clientX;
        const px = this._scrollXNode.scrollLeft + clientX - this._scrollXNode.getBoundingClientRect().left;
        const currentTime = px / this.getPPS();
        const frame = Math.trunc(currentTime*videoFrameRate);
        const groupName = e.target.getAttribute('group-name');
        const roundOfFrame = this.roundOfByFrame(frame, videoFrameRate);
        if(metadataByFrame.size) {
          const nodeDataAtFrame = this.state.metadataByFrame.get(frame).get(groupName);
          if(nodeDataAtFrame.length) {
            return nodeDataAtFrame[0];
          } else {
            return null;
          }
        } else {
          return null;
        }
        
  }

  onTimelineNodeMouseClick = (
    e: MouseEvent | FocusEvent | number,
    rowId: string,
    data: Object,
    fromAINode: boolean = false
  ) => {
    this.props.onDataTimeLineClick();
    if(!fromAINode && e.persist) {
      e.persist();
    }
    e.stopPropagation();
    e.preventDefault();
    if (!this.state.drawing) {
      if (this.dragHappen) {
        this.dragHappen = false;
      } else {
        this.setEventType(e, true);
        const nodeData = data ? data : this.fetchMetadataByFrame(e)
        if(nodeData) {
          this.onNodeClick(e, rowId, nodeData, fromAINode);
        } else {
          // do something handling
          return
        }
      }
    }
  };

  isAiNode = (node: object) => {
    if (node.isKeyFrameData) {
      return false;
    } else {
      return true;
    }
  };

  isAiNodePresentInContainer = () => {
    this.isAiNodePresent = false;
    if (this.nodeContainer.size) {
      this.nodeContainer.forEach((node) => {
        this.isAiNodePresent = this.isAiNodePresent ? this.isAiNodePresent : this.isAiNode(node);
      });
    }
  };

  setEventType = (e: MouseEvent, persistNodeContainer: boolean) => {
    this.eventType = e.type;
    this.ctrlKeyPress = e.ctrlKey || e.metaKey;
    this.shiftKeyPress = e.shiftKey;
    this.persistNodeContainer = persistNodeContainer;
  };

  onNodeClick = (e: MouseEvent | FocusEvent | number, rowId: string, data: Object, fromAINode: boolean = false) => {
    debug('[onNodeClick()] e: ', e);
    const clientX = typeof e === 'number' ? e : e.clientX;
    const isHoverEvent = (this._didPopupAppearFromHover = typeof e === 'number');
    const expandedRows = { ...this.state.expandedRows };
    const singleRow = true; //this.state.metadata.find((o) => o.key === rowId).value.length === 1;
    if (singleRow || expandedRows[rowId]) {
      const { controller } = this.props;
      let currentTime;
      if (clientX) {
        this.setState({ mouseX: clientX });
        if (!fromAINode) {
          const px = this._scrollXNode.scrollLeft + clientX - this._scrollXNode.getBoundingClientRect().left;
          currentTime = px / this.getPPS();
          if (!isHoverEvent) {
            controller.playing = false;
            if (!this.ctrlKeyPress) controller.setCurrentTime(currentTime, true);
          }
        }
        this.setActiveNode(data);
      } else {
        const { startTimeMs, stopTimeMs } = data;
        const start = startTimeMs / 1000;
        const end = stopTimeMs / 1000;
        currentTime = start + (end - start) / 2;
        controller.playing = false;
        controller.setCurrentTime(currentTime, true);
        if (this.props.ACTIVE_TIMELINE_NODE) {
          Store.put(ACTIVE_TIMELINE_NODE, null);
        }

        const node = e.target;
        setTimeout(() => {
          this.setActiveNode(data);
          // this.maybeScrollToActiveNode(node);
        }, 100);
      }
    } else if (!isHoverEvent) {
      this.onToggleRow(rowId);
    }
  };

  maybeClosePopup = () => {
    this.clearPopupTimer();
    const node = document.activeElement;
    if (node && node.tagName && node.tagName.toLowerCase() === 'input') {
      debug('[maybeClosePopup()] input in focus, not closing popup');
      return;
    }

    debug('[maybeClosePopup()] closing popup');
    this.onPopupClose();
  };

  onPopupClose = () => {
    // this.isDeletePopupOpen = false;
    if (this._didPopupAppearFromHover) {
      this._didPopupAppearFromHover = false;
      this.clearPopupTimer();
      this.removePopupMouseMoveListener();
    }

    if (this.state.mouseX) {
      this.setState({ mouseX: null });
    }
    Store.put(ACTIVE_TIMELINE_NODE, null);
  };

  onMetadataChange = (e: Event, field: Object) => {
    // TODO: how do we persist timeline metadata changes?
    debugger;
  };

  updateKeyframeMetadataData = (arr) => {
    updateKeyframeMetadata(arr, this.props.asset, this.fetchKeyframeMetadata);
  };

  onTimecodeChange = async (prop: string, value: number, data) => {
    try {
      this._isTimeCodeUpdate = true;

      const node = data; //this.props[ACTIVE_TIMELINE_NODE];
      node[prop] = value;
      const map = new HashMap();
      map.put(node.key, node.value);

      const entry = new KeyFrameMetadataEntry()
        .setId(node.id)
        .setStartTime(node.startTimeMs)
        .setEndTime(node.stopTimeMs)
        .setMetadataMap(map);

      if (prop === 'startTimeMs') {
        entry.setStartTime(value);
      } else if (prop === 'stopTimeMs') {
        entry.setEndTime(value);
      }

      const { asset } = this.props;

      await MetadataUtil.editKeyFrameMetadata(asset, [entry]);
      this.fetchKeyframeMetadata();
      // Store.put(ACTIVE_TIMELINE_NODE, null);
      // Store.put(ACTIVE_TIMELINE_NODE, node);
      this._isTimeCodeUpdate = false;
    } catch (err) {
      this._isTimeCodeUpdate = false;
      debug('[onSaveTimelineForm()] error: ', err);
      // toast(getErrorMessage(err));
    }
  };

  onChangeText = (field: Object, text: string) => {
    field.words[0].word = text;
    this.forceUpdate();
  };

  transformPropNames = (map: HashMap) => {
    const groupCodeToGroupInfo: HashMap = Store.get(GROUP_CODE_TO_GROUP_INFO);
    let groupInfo: GroupInfo = null;
    return _.sortBy(
      map
        .toArray()
        .filter(
          (entry) =>
            (groupInfo = groupCodeToGroupInfo.get(MetadataUtil.splitGroupCodeAndPropName(entry.key).groupCode)) &&
            groupInfo &&
            groupInfo.isShowInTimeline()
        )
        .map(({ key }) => ({
          value: key,
          label: key.substring(5)
        })),
      'label'
    );
  };

  onAddClick = () => {
    const { controller, onDataTimeLineClick } = this.props;
    const startTime = controller.currentTime * 1000;
    controller.playing = false;
    onDataTimeLineClick();
    this.setTimelineData(startTime, startTime + 1000, controller.frameRate);
  };

  setTimelineData = (startTime, endTime, frameRate) => {
    const dataTimeline = new DataTimeline(startTime, endTime, frameRate);
    this.setState({ dataTimeline, dialog: 'datatimeline', isPopupHide: true });
  };

  onAddDatapointClick = (e: MouseEvent, parentNode: HTMLDivElement, row: Object) => {
    const activeRowMetadataKey = row.key;

    const offset = parentNode.getBoundingClientRect().left;
    const left = e.clientX - offset;
    const startTimeMs = (left / this.getPPS()) * 1000;
    // let options: Object[] = this.transformPropNames(this.props.PROP_NAME_TO_PROP_INFO);
    // const isValueLabel = options.find((o) => o.value === activeRowMetadataKey);
    if (false) {
      this.addDataPoint(startTimeMs, startTimeMs + 1000, activeRowMetadataKey);
    } else {
      const map = new HashMap();
      map.put(activeRowMetadataKey, '');
      const keyFrameMetadataEntry = new KeyFrameMetadataEntry()
        .setId(-1)
        .setMetadataMap(map)
        .setStartTime(startTimeMs)
        .setEndTime(startTimeMs + 1000);
      this.setState({ keyFrameMetadataEntry, dialog: 'datapoint' });
    }
  };

  addDataPoint = (startTime: number, endTime: number, activeRowMetadataKey: string) => {
    const { controller } = this.props;
    const dataPointTarget = activeRowMetadataKey;
    const dataTimeline = new DataTimeline(startTime, endTime, controller.frameRate);
    this.setState({ dataTimeline, dialog: 'datatimeline', isPopupHide: true, dataPointTarget });
  };

  renderDataTimelineForm = () => {
    const { dataTimeline, dialog } = this.state;
    if (dialog !== 'datatimeline') {
      return null;
    }

    return (
      <DataTimelineDialog
        dataTimeline={this.state.dataTimeline}
        onClose={this.onCloseTimelineForm}
        onSubmit={this.onSaveTimelineForm}
        videoController={this.props.controller}
        dataPointTarget={this.state.dataPointTarget}
      />
    );
  };

  renderDatapointForm = () => {
    const { dataTimeline, keyFrameMetadataEntry, dialog } = this.state;
    if (dialog !== 'datapoint') {
      return null;
    }

    return (
      <TimelineDatapointDialog
        dataTimeline={dataTimeline}
        keyFrameMetadataEntry={keyFrameMetadataEntry}
        onClose={this.onCloseDatapointForm}
        onSubmit={this.onSaveDatapointForm}
        videoController={this.props.controller}
      />
    );
  };

  onCloseTimelineForm = () => {
    this.setState({ dataTimeline: null, dialog: null, isPopupHide: false, dataPointTarget: null });
    if (this.state.isWriteTimeEnable) {
      this.closeTimelineEditing();
      this.isVideoPlaying ? (this.props.controller.playing = true) : '';
    }
  };

  onSaveTimelineForm = async (dataTimeline: DataTimeline) => {
    try {
      const { asset, controller } = this.props;
      await MetadataUtil.editKeyFrameMetadata(asset, dataTimeline.entries);
      this.fetchKeyframeMetadata();
      this.onCloseTimelineForm();
      //   this.onKeyDownESCAPE();
      // if (!controller.playing()) {
      //   controller.playing(true);
      // }
    } catch (err) {
      debug('[onSaveTimelineForm()] error: ', err);
      // toast(getErrorMessage(err));
    }
  };

  onSaveDatapointForm = async () => {
    try {
      const { keyFrameMetadataEntry } = this.state;
      await MetadataUtil.editKeyFrameMetadata(this.props.asset, [keyFrameMetadataEntry]);
      this.fetchKeyframeMetadata();
      this.onCloseDatapointForm();
    } catch (err) {
      debug('[onSaveDatapointForm()] error: ', err);
      toast(getErrorMessage(err));
    }
  };

  onCloseDatapointForm = () => {
    this.setState({ keyFrameMetadataEntry: null, dialog: null });
    if (this.state.isWriteTimeEnable) {
      this.closeTimelineEditing();
      this.isVideoPlaying ? (this.props.controller.playing = true) : '';
    }
  };

  editTimelineMetadata = async (hashMap: HashMap, node: object) => {
    try {
      if (this._isTimeCodeUpdate || !hashMap.get('isKeyFrameData')) {
        return;
      }
      if (node && hashMap.get('value') == '') {
        this.putNodeIntoNodeContainer(node);
        this.setIsDelete();
      } else if (hashMap.get('key') != null) {
        const metadataMap = new HashMap();
        metadataMap.put(hashMap.get('key'), hashMap.get('value'));
        const keyFrameMetadataEntry = new KeyFrameMetadataEntry();
        keyFrameMetadataEntry.setEndTime(hashMap.get('stopTimeMs'));
        keyFrameMetadataEntry.setStartTime(hashMap.get('startTimeMs'));
        keyFrameMetadataEntry.setMetadataMap(metadataMap);
        keyFrameMetadataEntry.setId(hashMap.get('id'));
        debug('[editTimelineMetadata()] Saving keyframe metadata:', keyFrameMetadataEntry);
        await MetadataUtil.editKeyFrameMetadata(this.props.asset, [keyFrameMetadataEntry]);
      }
      this.fetchKeyframeMetadata();
    } catch (err) {
      debug('[editTimelineMetadata()] error: ', err);
    }
  };

  deleteMultipleNodes = () => {
    if (this.nodeContainer.size) {
      if (this.validateTimelineDeleteAction()) {
        this.setState({ isDelete: true, isPopupHide: true, deleteWho: 'nodeContainer' });
      } else {
        this.setActioneAlert(t('NOT_SUPPORT_DELETE_ACTION'));
      }
    }
  };

  setActioneAlert = (message) => {
    this.setState({ actioneAlert: true, isPopupHide: true, actionMsg: message });
  };

  closeActionAlert = () => {
    this.setState({ actioneAlert: false, isPopupHide: false, actionMsg: null });
  };

  renderActionAlertPopup = () => {
    const onClose = this.closeActionAlert;
    const modalProps = {
      name: 'DeleteAssetsModal',
      title: t('NOTICE'),
      onClose: onClose,
      children: this.state.actionMsg,
      buttons: [
        { label: '', onClick: onClose, type: 'CANCEL' },
        { label: t('DONE_LABEL'), onClick: onClose, type: 'PRIMARY' }
      ]
    };
    return <Modal {...modalProps} closeOnEsc={true} closeOnOutsideClick={true}></Modal>;
  };

  onCloseDeletePopup = (e) => {
    if (e) e.stopPropagation();
    this.setState({ isDelete: false, isPopupHide: false, deleteWho: null });
  };
  setIsDelete = () => {
    this.setState({ isDelete: true, isPopupHide: true, deleteWho: 'nodeContainer' });
  };

  renderDeletePopUp = () => {
    const { deleteWho } = this.state;
    if (deleteWho === 'nodeContainer') {
      const msg = this.nodeContainer.size === 1 ? t('TIMELINE_DELETE_ALT') : t('TIMELINE_DELETE_MULTIPLE');
      return this.getDeletePopUp(this.deleteKeyFrameMetadata, this.onCloseDeletePopup, msg);
    }
    if (deleteWho === 'row') {
      const msg = t('TIMELINE_DELETE_ROW');
      return this.getDeletePopUp(this.deleteRow, this.onCloseDeletePopup, msg);
    }
  };

  getDeletePopUp = (onDelete, onClose, message) => {
    const modalProps = {
      name: 'DeleteAssetsModal',
      title: t('CONFIRM'),
      onClose: onClose,
      children: message,
      buttons: [
        { label: t('CANCEL_LABEL'), onClick: onClose, type: 'CANCEL' },
        { label: t('DELETE_LABEL'), onClick: onDelete, type: 'PRIMARY' }
      ]
    };
    return <Modal {...modalProps} closeOnEsc={true} closeOnOutsideClick={true}></Modal>;
  };

  deleteKeyFrameMetadata = async () => {
    this.persistNodeContainer = true;
    // this.isDeletePopupOpen = false;
    try {
      const { asset } = this.props;
      if (debug.enabled) {
        debug('[deleteKeyFrameMetadata()] Deleting keyframe metadata:', node);
      }
      await MetadataUtil.deleteKeyFrameEntry(asset, this.nodeContainer);
      this.clearNodeContainer();
      this.setState({ isDelete: false, isPopupHide: false });
      this.fetchKeyframeMetadata();
    } catch (err) {
      debug('[deleteKeyFrameMetadata()] error:', err);
    }
  };

  getScaledWidth = () => {
    const { scale, width } = this.state;
    return scale * width;
  };

  /**
   * Returns the number of pixels per second.
   */
  getPPS = () => {
    const { duration } = this.props.controller;
    return duration ? this.getScaledWidth() / duration : 1;
  };

  getProgressLeft = () => {
    const { controller, clipConfig, CLIP_FROM_TIMELINE: clipFromTimeline } = this.props;
    const time = clipConfig.clipMode && !clipFromTimeline ? clipConfig.clipStart : controller.currentTime;
    const left = time * this.getPPS();
    return left;
  };

  getMaxHeight = (expandedRows: Object = this.state.expandedRows) => {
    let maxHeight = 40;
    this.state.metadata.forEach((row) => {
      if (expandedRows[row.key]) {
        maxHeight += row.value.length * 36;
      } else {
        maxHeight += 36;
      }
    });

    maxHeight = Math.min(maxHeight, window.innerHeight - 250);

    return maxHeight;
  };

  getIndexOfActiveRow = (): number => {
    const currentRowLabel = this.state.selectedRow ? this.state.selectedRow.label : this.state.activeRowLabel;
    const { metadata, activeRow } = this.state;
    for (let index = 0; index < metadata.length; index++) {
      if (metadata[index].label === currentRowLabel) {
        return index;
      }
    }
    return 0;
  };

  getProgressTop = (): number => {
    const indexOfActiveRow: number = this.getIndexOfActiveRow();
    const top: number = 36 * (indexOfActiveRow + 1) + 28;
    return top;
  };

  findActiveRow(): Object {
    const { metadata } = this.state;
    const activeRowData =
      _.size(this.state.activeRowLabel) > 0
        ? metadata.filter((r, i) => {
            return _.isEqual(MetadataTimelineSidebarRow.extractLabelAndLength(r).label, this.state.activeRowLabel);
          })
        : null;
    return activeRowData && activeRowData.length > 0 ? activeRowData[0] : this.state.activeRow;
  }

  renderRecordingIcon = () => {
    return this.props.isRecording ? (
      <div className="recording-icon">
        <img src={ThemeSetup.getImageURL('recording-video.svg')} />
      </div>
    ) : null;
  };

  renderBodyLeft = () => {
    //    debug('renderBodyLeft() Active Row Label: %s', this.state.activeRowLabel);
    const { metadata, expandedRows, disabledRows, hoveredRow, activeRow, selectedRowLabel } = this.state;
    const rows = metadata.map((r, i) => (
      <MetadataTimelineSidebarRow
        key={i}
        data={r}
        isExpanded={expandedRows[r.key]}
        isDisabled={disabledRows[r.key]}
        isHovered={r.key === hoveredRow}
        isActive={_.isEqual(MetadataTimelineSidebarRow.extractLabelAndLength(r).label, this.state.activeRowLabel)}
        onToggle={this.onToggleRow}
        onDisable={this.onDisableRow}
        onMouseEnter={this.onRowMouseEnter}
        onMouseLeave={this.onRowMouseLeave}
        onToggleActiveRow={this.onToggleActiveRow}
        isClicked={r.key == selectedRowLabel}
        onRowClick={this.onRowClick}
      />
    ));
    return (
      <div className="body-left" ref={(node) => (this._sidebarNode = node)} onWheel={this.onSidebarWheel}>
        {rows}
        <div className="add-row">
          <Button
            icon={ThemeSetup.getImageURL('plus-circle.svg')}
            text={t('ADD_DATA_TIMELINE')}
            onClick={this.onAddClick}
          />
        </div>
      </div>
    );
  };

  getLeft = () => {
    let left = 0;
    if (this.popupRef) {
      left = this.popupRef._dragOneEnd ? this._progressBarNode.style.left : this.getProgressLeft();
    } else {
      left = this.getProgressLeft();
    }
    return left;
  };

  renderProgressTrail = () => {
    return <div className="progress-trail" style={{ width: this.getLeft() }} />;
  };

  renderProgressBar = (isClipStart: boolean = false, isClipEnd: boolean = false) => {
    const svgProps: Object = {
      className: 'progress-bar',
      version: '1.1',
      xmlns: 'http://www.w3.org/2000/svg'
    };

    const polygonProps: Object = {
      points: '0,0 7,0 7,8 3.5,10 0,8',
      fill: 'var(--primary-style-color)'
    };

    const ref = (node) => (this._progressBarNode = node);

    if (!(isClipStart || isClipEnd)) {
      svgProps.style = { left: this.getLeft() };
      svgProps.ref = ref;
      polygonProps.onMouseDown = this.onProgressBarMouseDown;
    }

    if (isClipStart) {
      svgProps.ref = ref;
    }

    return (
      <svg {...svgProps}>
        <polygon {...polygonProps} />
        <line x1={3.5} y1={0} x2={3.5} y2="100%" stroke="var(--primary-style-color)" />
      </svg>
    );
  };

  renderTimelineNode = () => {
    const { startTime } = this._timelineConfig;
    const left: number = startTime * this.getPPS();

    return (
      <div
        className="timeline-node"
        style={{ left: left, width: this.getProgressLeft() - left, top: this.getProgressTop() }}
      />
    );
  };

  renderClipBars = () => {
    const { clipConfig, controller } = this.props;
    const { width } = this.state;
    const pps = this.getPPS();
    const bodyWidth = (clipConfig.clipEnd - clipConfig.clipStart) * pps;

    const start = <div className="clipbar">{this.renderProgressBar(true, false)}</div>;
    const cursor = <div className="clipbar clipbar-cursor">{this.renderProgressBar()}</div>;
    const body = <div className="clipbody" style={{ width: bodyWidth }} />;
    const end = <div className="clipbar">{this.renderProgressBar(false, true)}</div>;
    const bgStyleLeft = {
      width: clipConfig.clipStart * pps
    };
    const bgStyleRight = {
      left: clipConfig.clipEnd * pps,
      width: (controller.duration - clipConfig.clipEnd) * pps
    };

    return (
      <div className="clipbar-wrapper">
        <div className="clip-bg clip-bg-left" style={bgStyleLeft} />
        <div className="clip-bg clip-bg-right" style={bgStyleRight} />
        {clipConfig.renderClipStart(pps, start)}
        {/* {clipConfig.renderClipCursor(pps, cursor)} */}
        {clipConfig.renderClipBody(pps, body)}
        {clipConfig.renderClipEnd(width, pps, end)}
      </div>
    );
  };

  renderTimelineBars = () => {
    const { clipConfig, controller } = this.props;
    const { width } = this.state;
    const pps = this.getPPS();
    const { startTime } = this._timelineConfig;
    const bodyWidth = (controller.currentTime - startTime) * pps;
    if (this._timelineConfig.startMarker === null) {
      this._timelineConfig.startMarker = <div className="clipbar">{this.renderProgressBar()}</div>;
    }

    const timelineNode = this.renderTimelineNode();

    // const start = <div className="clipbar">{this.renderProgressBar(true, false)}</div>;
    //const body = <div className="clipbody" style={{ width: bodyWidth }} />;
    const end = <div className="clipbar">{this.renderProgressBar()}</div>;

    //const bgStyleLeft = {width:  startTime * pps};
    const bgStyleLeft = { width: startTime * pps };
    const bgStyleRight = {
      left: controller.currentTime * pps,
      width: (controller.duration - controller.currentTime) * pps
    };

    const { startMarker } = this._timelineConfig;
    return (
      <div className="clipbar-wrapper">
        <div className="clip-bg clip-bg-left" style={bgStyleLeft} />
        <div className="clip-bg clip-bg-right" style={bgStyleRight} />
        {startMarker}
        {timelineNode}
        {end}
      </div>
    );
  };

  renderNodeLine = (startTimeMs: Number, stopTimeMs: Number, pps: Number) => {
    const color = '#2196f3';
    const x1 = startTimeMs > -1 ? (startTimeMs / 1000) * pps : (stopTimeMs / 1000) * pps;
    const x2 = stopTimeMs > -1 ? (stopTimeMs / 1000) * pps : (startTimeMs / 1000) * pps;
    const y = 16;
    return (
      <div>
        <g name="MetaTimelineNode">
          <line x1={x1} x2={x2} y1={y} y2={y} data-color={color.replace('#', '')} strokeLinecap="round" />
        </g>
      </div>
    );
  };

  renderBodyRight = () => {
    const { controller, assetAiData } = this.props;
    const {
      metadata,
      expandedRows,
      disabledRows,
      hoveredRow,
      cellConfig,
      selectedRowLabel,
      isDrag,
      isMouseDown
    } = this.state;
    const offsetLeft = this._scrollXNode ? this._scrollXNode.getBoundingClientRect().left : 0;
    const pps = this.getPPS();
    const getProgressLeft = this.getProgressLeft();
    if (!metadata.length) {
      return null;
    }

    const rows = metadata.map((r, i) => (
      <MetadataTimelineRow
        loading={!controller.duration}
        duration={controller.duration}
        key={i}
        data={r}
        isKeyFrameData={r.isKeyFrameData}
        getBoundaryOfRows={this.getBoundaryOfRows}
        type={r.key}
        pps={pps}
        cellConfig={cellConfig}
        isMouseDown={isMouseDown}
        isDrag={isDrag}
        isExpanded={expandedRows[r.key]}
        isDisabled={disabledRows[r.key]}
        isHovered={r.key === hoveredRow}
        isClicked={r.key == selectedRowLabel}
        onMouseEnter={this.onRowMouseEnter}
        onMouseLeave={this.onRowMouseLeave}
        onRowClick={this.onRowClick}
        onTimelineNodeMouseClick={this.onTimelineNodeMouseClick}
        onTimelineNodeMouseEnter={this.onTimelineNodeMouseEnter}
        onTimelineNodeMouseLeave={this.onTimelineNodeMouseLeave}
        onTimelineNodeMouseMove={this.onTimelineNodeMouseMove}
        onAddClick={this.onAddDatapointClick}
        onMouseDown={this.onMouseDown}
        mouseMove={this.mouseMove}
        mouseUp={this.mouseUp}
      />
    ));

    return (
      <div
        className="body-right scroll-y"
        style={{ width: this.getScaledWidth() }}
        onScroll={this.onScrollY}
        ref={(node) => (this._scrollYNode = node)}>
        {rows}
        <div className="add-row" />
      </div>
    );
  };

  getPositionOfMetaDataTimeline = () => {
    return this._node ? this._node.getBoundingClientRect() : null;
  };

  arrowKeyPress = (e) => {
    if (this.popupRef) this.popupRef.onPressArrowKey(e);
  };

  validateTimelineDeleteAction = () => {
    if (this.isAiNodePresent) return false;
    else return true;
  };

  validateTimelineDragAction = () => {
    if (this.isAiNodePresent) return false;
    else return true;
  };

  validateTimelineMoveAction = () => {
    if (this.isAiNodePresent) return false;
    else return true;
  };

  renderTimelinePopup = () => {
    let node = this.props[ACTIVE_TIMELINE_NODE];
    if (!node && this.nodeContainer.size) {
      node = this.nodeContainer.values().next().value;
    }
    if (!node) {
      return null;
    }
    let rect = this.getRect(node);
    if (!rect || this.props.isHide) {
      return null;
    }
    const { mouseX } = this.state;
    const left = mouseX || rect.left + rect.width / 2;
    const offsetLeft = this._scrollXNode ? this._scrollXNode.getBoundingClientRect().left : 0;
    const event = this.eventType;
    if (this.eventType === 'click') this.keyModifierActions(node);
    return (
      <TimelinePopup
        popupRef={(ref) => (this.popupRef = ref)}
        data={node}
        getDeletePopUp={this.getDeletePopUp}
        deleteMultipleNodes={this.deleteMultipleNodes}
        isAiNodePresent={this.isAiNodePresent}
        setActioneAlert={this.setActioneAlert}
        updateKeyframeMetadataData={this.updateKeyframeMetadataData}
        validateTimelineMoveAction={this.validateTimelineMoveAction}
        isAiNode={this.isAiNode}
        nodeContainer={this.nodeContainer}
        getPositionOfMetaDataTimeline={this.getPositionOfMetaDataTimeline}
        getBoundaryOfRows={this.getBoundaryOfRows}
        _node={this._node}
        controller={this.props.controller}
        style={{ bottom: window.innerHeight - rect.top + 10, left }}
        clearNodeContainer={this.clearNodeContainer}
        rect={rect}
        isPopupHide={this.state.isPopupHide}
        coordinates={this.coordinates}
        getRect={this.getRect}
        isDrag={this.state.isDrag}
        event={event}
        offsetLeft={offsetLeft}
        scrollLeft={this._scrollXNode.scrollLeft}
        getPPS={this.getPPS}
        onTimecodeChange={this.onTimecodeChange}
        onClose={this.onPopupClose}
        doPersistNodeContainer={this.doPersistNodeContainer}
        onChange={(hashMap, node) => this.editTimelineMetadata(hashMap, node)}
        onDelete={this.deleteKeyFrameMetadata}
      />
    );
  };

  renderScale = () => {
    const { clipMode } = this.props.clipConfig;
    const scale = (
      <div className="scale flex-row align-center" ref={!clipMode ? this.onScaleNodeRef : undefined}>
        <span>Zoom (time)</span>
        <RangeInput
          value={this.state.inputScale}
          min={1}
          max={10}
          step={0.01}
          onChange={(e) => this.onScaleChange(e, e.target.getAttribute('value'))}
          onMouseUp={() => (this.updateRange = false)}
          onMouseDown={() => (this.updateRange = true)}
        />
      </div>
    );

    if (!clipMode) {
      return scale;
    }

    const style = { top: '96%', left: '0.5%', background: 'var(--primary-header-bg)' }; //this._scaleNodeRect ? { top: this._scaleNodeRect.top, left: this._scaleNodeRect.left } : {};
    return (
      <Portal defaultOpen={true}>
        <div name="MetadataTimeline_Portal" style={style}>
          {scale}
        </div>
      </Portal>
    );
  };

  getObjectText = (o: Object) => {
    if (!o) {
      return null;
    }

    const { object = {}, words = [], value } = o;
    const { name, label, type } = object;

    if (words.length) {
      return o.words[0].word;
    }

    return name || label || type || value;
  };

  getPoints = (arr: Object[], width: number, height: number) => {
    const points = arr.map(({ x, y }) => {
      return `${x * width},${y * height}`;
    });

    return points.join(' ');
  };

  //// d=data, t=target, s=start, e=end, m=middle
  searchCurrentItems = (d: Array, t: number, s: number, e: number) => {
    const m = Math.floor((s + e) / 2);
    if (t >= d[m].startTimeMs / 1000 && t <= d[m].stopTimeMs / 1000) {
      return this.deepSearchItems(d, m, d[m].startTimeMs);
    }
    if (e === 0) {
      return null;
    }
    if (e - 1 === s) {
      if (t >= d[s].startTimeMs / 1000 && t <= d[s].stopTimeMs / 1000) {
        return this.deepSearchItems(d, s, d[s].startTimeMs);
      }
      if (t >= d[e].startTimeMs / 1000 && t <= d[e].stopTimeMs / 1000) {
        return this.deepSearchItems(d, e, d[e].startTimeMs);
      }
      return null;
    }
    if (t > d[m].startTimeMs / 1000) {
      return this.searchCurrentItems(d, t, m, e);
    }
    if (t < d[m].startTimeMs / 1000) {
      return this.searchCurrentItems(d, t, s, m);
    }
  };

  //// d=data i=index s=startTime e=endTime --- IT WILL CALL ONLY WHEN DATA MATCHED TO FIND OTHER ITEMS ON SAME TIMESPAN
  deepSearchItems = (d: Array, i: number, s: number): Array => {
    const items = new Array();
    for (let si = i; si >= 0; si--) {
      if (d[si].startTimeMs == s) {
        items.push(d[si]);
      } else {
        break;
      }
    }
    for (let ei = i; ei < d.length; ei++) {
      if (d[ei].startTimeMs == s) {
        i == ei || items.push(d[ei]);
      } else {
        break;
      }
    }
    return items;
  };

  getPointsForAiData = (item, width: number, height: number) => {
    if (item._boundingBox && item._boundingBox.length > 0) {
      const points: Array<Point> = item._boundingBox[0].getPoints();
      const outPoints: Array<number> = this.calculateSvgPoints(points, width, height);
      return outPoints;
    }
  };

  calculateSvgPoints = (inputPoints: Array<Point>, width: number, height: number): Array<number> => {
    const points = [];
    for (let index = 0; index < inputPoints.length; index++) {
      const p: Point = inputPoints[index];
      let xPoint: number = width * p.getX();
      let yPoint: number = height * p.getY();

      if (xPoint < 0) {
        xPoint = 0;
      }
      if (yPoint < 0) {
        yPoint = 0;
      }
      if (xPoint > width) {
        xPoint = width;
      }
      if (yPoint > height) {
        yPoint = height;
      }
      points.push(xPoint);
      points.push(yPoint);
    }
    return points;
  };

  renderActiveRow = () => {
    const { controller } = this.props;
    const { activeRow } = this.state;
    const { currentTime } = this.props.controller;
    if (!controller.duration || !activeRow || activeRow.length < 1) {
      return null;
    }
    const objects = this.searchCurrentItems(activeRow, currentTime, 0, activeRow.length - 1);
    if (!objects || objects.length < 1) {
      return null;
    }

    let markup, markupText, style, styleText;
    if (objects[0]._boundingBox && objects[0]._boundingBox.length > 0) {
      let node = document.querySelector('.DrawingCanvasContainer');

      if (!node) {
        markup = null;
      } else {
        node = node.firstElementChild;

        const { top, left, width, height } = node.getBoundingClientRect();

        style = { top, left, width, height };
        markup = (
          <svg className="visual-metadata" viewBox={`0 0 ${width} ${height}`} xmlns="http://www.w3.org/2000/svg">
            {objects.map((o, i) => (
              <polygon
                key={i}
                stroke="#eb6a5c"
                strokeWidth="3"
                fill="none"
                points={this.getPointsForAiData(o, width, height)}
                //points={this.getPoints(o.object.boundingPoly, width, height)}
              />
            ))}
          </svg>
        );
      }
    }
    // if (this.getObjectText) {
    const rect = this._node ? this._node.getBoundingClientRect() : {};
    styleText = { bottom: window.innerHeight - rect.top + 20, left: rect.left + rect.width / 2 };

    const text = objects.map(this.getObjectText).join(', ');
    if (!text) {
      markupText = null;
    } else {
      markupText = Array.isArray(objects[0].words) ? (
        <MetadataVideoOverlay
          text={text}
          controller={controller}
          onChangeText={(text: string) => this.onChangeText(objects[0], text)}
        />
      ) : (
        <div className="text" name={this.state.forceId + 'markUpTextForForce'}>
          {text}
        </div>
      );
    }
    // }

    if (!markup && !markupText) {
      return null;
    }

    return (
      <React.Fragment>
        {markup ? (
          <Portal defaultOpen={true}>
            <div name="MetadataTimeline_Portal2" style={style}>
              {markup}
            </div>
          </Portal>
        ) : null}
        {markupText ? (
          <Portal defaultOpen={true}>
            <div name="MetadataTimeline_Portal2" style={styleText}>
              {markupText}
            </div>
          </Portal>
        ) : null}
      </React.Fragment>
    );
  };

  renderSvgDefs = () => {
    const colors = MetadataUtil._timelineColors;

    return (
      <svg>
        <defs>
          {colors.map((color: string, i: number) => (
            <linearGradient key={i} id={`linear-gradient-${color.replace('#', '')}`} x1="0" x2="0" y1="0" y2="1">
              <stop offset="0%" stopColor={`${color}08`} />
              <stop offset="50%" stopColor={`${color}77`} />
              <stop offset="100%" stopColor={`${color}08`} />
            </linearGradient>
          ))}
        </defs>
      </svg>
    );
  };

  render() {
    const {
      controller,
      videoFrameRate,
      clipConfig,
      CLIP_FROM_TIMELINE: clipFromTimeline,
      metadataTimelineSeekChangeEvents,
      isRecording,
      mediaLoadFailed,
      isHide = false
    } = this.props;
    const { metadata, width, height, scale, hasScrolledTop, hasScrolledLeft, isWriteTimeEnable } = this.state;
    const { currentTime, duration } = controller;
    const newHeight = 100 + metadata.length * 36;
    if (Store.get(ONLOCATE_VIA_ADV_SEARCH)) this.highlightStoreNode();
    const selectRangeStyle = {
      height: `${this.state.drawBoxHeight}px`,
      width: `${this.state.drawBoxWidth}px`,
      left: `${this.state.drawBoxTopLeft}px`,
      top: `${this.state.drawBoxTop}px`
    };
    return (
      <div
        name="MetadataTimeline"
        className={classNames({ 'scrolled-left': hasScrolledLeft, 'scrolled-top': hasScrolledTop, 'hidden': isHide })}
        style={{ height }}
        ref={(node) => (this._node = node)}
        onClick={this.onMetaDataMouseClick}>
        <Draggable handle=".handle" axis="y" onStop={this.onResizeStop} ref={(inst) => (this._draggable = inst)}>
          <div className="drag" name="Draggable">
            <div className="handle">
              <div className="handle-inner" />
            </div>
            <div className="indicator" />
          </div>
        </Draggable>
        <div className="content">
          <div className="header-left">
            <PlaybackTimer
              progress={currentTime}
              duration={duration}
              videoFrameRate={videoFrameRate}
              controller={controller}
            />
            {this.renderRecordingIcon()}
          </div>
          {this.renderBodyLeft()}
          <div className="right" ref={(node) => (this._scrollXNode = node)} onScroll={this.onScrollX}>
            <MetadataTimelineHeader
              controller={controller}
              scale={scale}
              width={width}
              seekChangeEvents={metadataTimelineSeekChangeEvents}
            />
            <div className="timeline-row" onMouseDown={this.onMetaDataMouseDown} onMouseMove={this.onMetaDataMouseMove}>
              {this.renderBodyRight()}
            </div>

            {this.renderProgressTrail()}
            {isWriteTimeEnable ? (
              this.renderTimelineBars()
            ) : (
              <div>{clipConfig.clipMode && !clipFromTimeline ? this.renderClipBars() : this.renderProgressBar()}</div>
            )}
          </div>
          <div className="scroll-shadow x" />
          <div className="scroll-shadow y" />
        </div>
        {this.renderActiveRow()}
        
        {!mediaLoadFailed ? this.renderScale() : null}

        {this.renderTimelinePopup()}
        {this.renderDataTimelineForm()}
        {this.renderDatapointForm()}
        <KeyboardHelpTextBottom msg={this.state.showKeyboardHelpHelpText} />
        {this.state.isMouseDown ? (
          <div
            className="draw-box"
            style={selectRangeStyle}
            ref={this.mouseSelection}
            onMouseMove={this.onMetaDataMouseMove}
          />
        ) : null}
        {this.state.isDelete ? this.renderDeletePopUp() : null}
        {this.state.actioneAlert ? this.renderActionAlertPopup() : null}
      </div>
    );
  }
}

type KeyboardHelpTextBottomPropState = {
  msg: ?string
};

class KeyboardHelpTextBottom extends React.PureComponent<KeyboardHelpTextBottomPropState> {
  render() {
    return this.props.msg !== null ? (
      <div className="activeEditTimelineMsg">{i18nHas(this.props.msg) ? t(this.props.msg) : this.props.msg}</div>
    ) : null;
  }
}
